export default __webpack_public_path__ + "static/media/Payroll.657e1c87.png";